import {getSessionData} from "./global-util";

const SESSION_COOKIE_NAME = 'JSESSIONID-DP';
const SESSION_EXPIRY_COOKIE_NAME = 'sessionExpiry';
const SERVER_TIME_COOKIE_NAME = 'serverTime';

function getCookie(name, path) {

  // New way of getting cookies (can use path)
  // if (path) {
  //     const cookieArray = browser.cookies.getAll({
  //       name: name,
  //       path: path,
  //     });
  //     if (cookieArray && cookieArray.length > 0) {
  //       //take last cookie - sorted by creation date
  //
  //       console.log(cookieArray[cookieArray.length]);
  //     }
  // }
  //if path not supplied or no results or not supported, fall back to old way, next

  // Old way of getting cookies (doesn't support path)
  const cookie = {};
  document.cookie.split(';').forEach((el) => {
    const [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });
  return cookie[name];
}

// Get session cookie set at login, use context root if set otherwise at root
function getSessionCookie() {
  const contextRoot = getSessionData('contextRoot');
  const cookiePath = (contextRoot && contextRoot !== '/') ? contextRoot : undefined;
  return getCookie(SESSION_COOKIE_NAME, cookiePath);
}

// Get session expiry (datetime) cookie set at login, use context root if set otherwise at root
function getSessionExpiryTimeCookie() {
    const contextRoot = getSessionData('contextRoot');
    const cookiePath = (contextRoot && contextRoot !== '/') ? contextRoot : undefined;
    return getCookie(SESSION_EXPIRY_COOKIE_NAME, cookiePath);
}

// Get session expiry (datetime) cookie set at login, use context root if set otherwise at root
function getServerTimeCookie() {
    const contextRoot = getSessionData('contextRoot');
    const cookiePath = (contextRoot && contextRoot !== '/') ? contextRoot : undefined;
    return getCookie(SERVER_TIME_COOKIE_NAME, cookiePath);
}

function updateSSLCookie() {
    const d = new Date();
    d.setTime(d.getTime() + (180*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    const value = getCookie('_WL_AUTHCOOKIE_' + SESSION_COOKIE_NAME);
    if(value !== undefined)
    {
        document.cookie = '_WL_AUTHCOOKIE_' + SESSION_COOKIE_NAME + "=" + value + ";" + expires + ";path=" + getSessionData('contextRoot');
    }
}

export { getCookie, getSessionCookie, getSessionExpiryTimeCookie, getServerTimeCookie, updateSSLCookie, SESSION_COOKIE_NAME };
